import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import { Permission } from 'garaje/utils/ui-permissions';

export default class MacAddressMappingAbility extends Ability {
  @service declare authz: AuthzService;

  get canView(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.INTEGRATIONS_MAC_ADDRESS_MANAGE);
  }

  get canManage(): boolean {
    return this.authz.hasPermissionAtCurrentCompany(Permission.INTEGRATIONS_MAC_ADDRESS_MANAGE);
  }
}
